import { hue } from "./hue.js";

/**
 * @typedef {Object} Options
 * @property {string} color - The color to generate the range from
 * @property {number} steps - The number of steps in the range
 * @property {string} outputFormat - The format of the output color
 * @property {number} hueChange - The amount to change the hue by
 */

/**
 * @typedef {Object} BoldOptions
 * @property {object} property
 * @property {string} color - The color to generate the range from
 * @property {number} steps - The number of steps in the range
 * @property {string} outputFormat - The format of the output color
 */

/**
 * @param {Options} param
 * @returns {string[]} The range of colors
 */
export function analagousIncreasing({ color, steps = 3, outputFormat = "hex" }) {
  const hueChange = 30;

  return hue({
    color,
    steps,
    outputFormat,
    hueChange: hueChange,
  });
}

/**
 * @param {Options} param
 * @returns {string[]} The range of colors
 */
export function analagousDecreasing({ color, steps = 3, outputFormat = "hex" }) {
  const hueChange = -30;

  return hue({
    color,
    steps,
    outputFormat,
    hueChange: hueChange,
  });
}

/**
 * @param {BoldOptions} param
 * @returns {string[]} The range of colors
 * */
export function triadIncreasing({ color, steps = 3, outputFormat = "hex" }) {
  const hueChange = 60;

  return hue({
    color,
    steps,
    outputFormat,
    hueChange,
  });
}

/** @param {BoldOptions} param */
export function triadDecreasing({ color, steps = 3, outputFormat = "hex" }) {
  const hueChange = -60;

  return hue({
    color,
    steps,
    outputFormat,
    hueChange,
  });
}